import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
import './carnival.css';
import {toast} from "react-toastify";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import CardSection from 'components/sales/cardSection/cardSection';
import Images from 'assets/images/imageData';

const CarnivalDetailsBa = ({
  getSiteCarnivalChecklist,
  siteData,
  match,
  history,
  documentUploadUrl,
  postReportDetails,
  generateReport,
  getLocationApprovalPending,
  location,
  locationApproval,
  getPocBySiteId,
  pocListBySiteId,
  postSendReportMail,
  getCheckLocation,
  locationCheck,
  userProfile,
  getSiteData,
  calculateDistance,
  engDistanceData,
  siteDetails,
  getDistanceData,
  distanceDetails,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  postCarnivalData,
  getCarnivalCompletedDetails,
  checklistDetails
}) => {
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isChecklistFilled, setCheckListDetails] = useState([]);
 

  useEffect(() => {
    if(getCarnivalCompletedDetails) {
      (async () => {
        await getCarnivalCompletedDetails(match.params.id, match.params.stageId);
      })(); 
    }
  },[getCarnivalCompletedDetails]);

  useEffect(() => {
     if(checklistDetails !== undefined && checklistDetails !== null) {
          setCheckListDetails(checklistDetails);
     }
  },[checklistDetails]);


  return (
    <Layout
      title={`Carnival Details`}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}/${match.params.leadId}`}
      // linkUrl={`/dashboard/carnival/carnival-conduct/${match.params.id}/stage/${match.params.stageId}/${match.params.leadId}`}
    >
    <div className="container-fluid">
      {/* <div className="panel-card card-details">
        <div className="panel-heading">{`Carnival Details`}</div>
          <div className="panel-body"> */}
            {(isChecklistFilled && isChecklistFilled !== undefined && isChecklistFilled?.length > 0) ?
            <>
            {isChecklistFilled.map((v,i) => {
              return (
                <div className="panel-card card-details">
                  <div className="panel-heading">{`Carnival Details ${i+1}`}</div>
                  <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={`Created By`}
                      data={v?.created_by_user}
                    />
                    <DivLayout
                      heading={`Created On`}
                      data={v?.created_at}
                    />
                    {v.details !== undefined && v.details.length > 0 && 
                    <>
                    <div className='container'>
                    <table className='panel-table'>
                        <thead>
                          <tr>
                            <th>Question</th>
                            <th>Answer</th>
                          </tr>
                        </thead>
                        <tbody>
                    {v.details.map((q,k) => {
                      return (
                        
                          <tr>
                            <td>{q?.question}</td>
                            <td>{q?.answer}</td>
                          </tr>
                        
                      )  
                    })}
                    </tbody>
                    </table>
                    </div>
                    </>
                    }
                  </div>  
                  </div>
                </div>
              )
            })}
            </>
            : <div><img src={Images?.NoData} alt="" width="100%" /></div>
          }
          
        {/* </div>
      </div> */}
    </div>
    </Layout>
  );
};
export default CarnivalDetailsBa;
